<template>
  <div class="elegant-activity-page">
    <div v-if="JSON.stringify(obj)!=='{}'">
      
      <!-- 主要內容區域 -->
      <div class="main-content">
        
        <!-- 活動標題區塊 -->
        <div class="title-block">
          <div class="title-container">
            <div v-if="mytheme.length>0" class="activity-badges">
              <span class="badge theme-badge" v-text="covert('theme',obj.theme)"></span>
              <span class="badge type-badge" v-text="obj.title"></span>
              <span class="badge info-badge" v-text="obj.atitle+' | '+obj.descs"></span>
            </div>
            <h1 class="main-title" v-text="obj.actitle"></h1>
            
            <!-- 收藏按鈕 -->
            <div v-if="user!==null && show" class="favorite-section">
              <a-button type="primary" size="large" :loading="iconLoading" @click="enterIconLoading" class="favorite-btn">
                <span class="heart-icon">♥</span>
                加入我的最愛
              </a-button>
            </div>
          </div>
        </div>

        <!-- 活動主圖 -->
        <div class="image-section">
          <div class="image-wrapper">
            <img
              class="main-image"
              :src="obj.url!==''? obj.url:catImg('event_1080x540.png')"
              alt="活動主圖"
            />
          </div>
        </div>

        <!-- 時間資訊卡 -->
        <div class="info-card time-card full-width">
          <div class="card-header">
            <div class="icon-wrapper time-icon">
              <b-icon icon="clock"></b-icon>
            </div>
            <h3>活動時間</h3>
          </div>
          <div class="card-content">
            <div v-if="obj.edate==obj.sdate" class="time-content-wrapper">
              <div class="time-header">
                <div class="time-type single">單日活動</div>
                <div class="day-info" v-text="getDay(obj.sdate)"></div>
              </div>
              <div class="time-details">
                <div class="time-info" v-text="obj.sdate +' '+  obj.stime.substring(0, 5) +' ~ ' + (obj.edate==obj.sdate?'':obj.edate) +' '+  obj.etime.substring(0, 5)"></div>
              </div>
            </div>
            <div v-if="obj.edate!=obj.sdate" class="time-content-wrapper">
              <div class="time-header">
                <div class="time-type multi">多天活動</div>
                <div class="time-period">{{ obj.sdate + ' ~ ' + obj.edate }}</div>
              </div>
              <div class="time-details">
                <div v-if="obj.datetype==false" class="day-list">                
                  <span v-for="day in getDateData(obj.acts_actclass)" :key="day" class="day-item">{{day}}</span>
                </div>                  
                <div v-else class="schedule-times-container">
                  <!-- 時間列表統計 -->
                  <div class="schedule-summary">
                    <span class="total-count">共 {{ obj.multiples.length }} 個時段</span>
                    <div class="view-controls">
                      <button 
                        class="view-btn"
                        :class="{ active: viewMode === 'compact' }"
                        @click="viewMode = 'compact'"
                      >
                        緊湊顯示
                      </button>
                      <button 
                        class="view-btn"
                        :class="{ active: viewMode === 'expanded' }"
                        @click="viewMode = 'expanded'"
                      >
                        展開顯示
                      </button>
                    </div>
                  </div>
                  
                  <!-- 緊湊模式 - 分頁顯示 -->
                  <div v-if="viewMode === 'compact'" class="schedule-compact">
                    <div class="schedule-times">
                      <div 
                        v-for="item in getCurrentPageItems" 
                        :key="item.id" 
                        class="schedule-item"
                      >
                        {{ formatScheduleTime(item) }}
                      </div>
                    </div>
                    <div class="pagination-controls" v-if="totalPages > 1">
                      <button 
                        class="page-btn"
                        :disabled="currentPage === 1"
                        @click="currentPage--"
                      >
                        上一頁
                      </button>
                      <span class="page-info">
                        {{ currentPage }} / {{ totalPages }}
                      </span>
                      <button 
                        class="page-btn"
                        :disabled="currentPage === totalPages"
                        @click="currentPage++"
                      >
                        下一頁
                      </button>
                    </div>
                  </div>
                  
                  <!-- 展開模式 - 按月份分組 -->
                  <div v-else class="schedule-expanded">
                    <div v-for="(group, month) in getGroupedByMonth" :key="month" class="month-group">
                      <h4 class="month-header">{{ month }}</h4>
                      <div class="schedule-times">
                        <div 
                          v-for="item in group" 
                          :key="item.id" 
                          class="schedule-item"
                        >
                          {{ formatScheduleTime(item) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 基本資訊卡 -->
        <div class="info-card basic-info full-width">
          <div class="card-header">
            <div class="icon-wrapper info-icon">
              <b-icon icon="info-circle"></b-icon>
            </div>
            <h3>活動資訊</h3>
          </div>
          <div class="card-content">
            <div class="info-row">
              <span class="label">主辦單位</span>
              <span class="value" v-text="orgName"></span>
            </div>
            <div class="info-row">
              <span class="label">活動地點</span>
              <span class="value" v-text="obj.address"></span>
            </div>
            <div class="info-row">
              <span class="label">聯絡電話</span>
              <span class="value" v-text="obj.hphone==''?'無提供':obj.hphone"></span>
            </div>
            <div class="info-row">
              <span class="label">手機</span>
              <span class="value" v-text="obj.mphone==''?'無提供':obj.mphone"></span>
            </div>
            <div class="info-row">
              <span class="label">Email</span>
              <span class="value" v-text="obj.email"></span>
            </div>
          </div>
        </div>

        <!-- 其他資訊卡片群組 -->
        <div class="info-grid">

          <!-- 學分資訊卡 -->
          <div class="info-card credit-card">
            <div class="card-header">
              <div class="icon-wrapper credit-icon">
                <b-icon icon="award"></b-icon>
              </div>
              <h3>獎勵學分</h3>
            </div>
            <div class="card-content">
              <div class="credit-grid">
                <div class="credit-item">
                  <span class="credit-role">講師</span>
                  <span class="credit-value">{{obj.coach}}</span>
                </div>
                <div class="credit-item">
                  <span class="credit-role">志工</span>
                  <span class="credit-value">{{obj.volunteer}}</span>
                </div>
                <div class="credit-item">
                  <span class="credit-role">參加者</span>
                  <span class="credit-value">{{obj.actor}}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 連結資訊卡 -->
          <div class="info-card link-card">
            <div class="card-header">
              <div class="icon-wrapper link-icon">
                <b-icon icon="link-45deg"></b-icon>
              </div>
              <h3>相關連結</h3>
            </div>
            <div class="card-content">
              <div v-if="obj.sinkurl!==''" class="link-item">
                <a :href="ensureHttps(obj.sinkurl)" target="_blank" rel="noopener noreferrer" class="external-link">
                  查看官方網站
                  <b-icon icon="arrow-up-right"></b-icon>
                </a>
              </div>
              <div v-else class="no-link">暫無相關連結</div>
              
              <div v-if="obj.checked" class="restriction-info">
                <div class="restriction-label">報名限制</div>
                <div class="restriction-value" v-text="obj.value"></div>
              </div>
            </div>
          </div>

        </div>

        <!-- 費用資訊 -->
        <div v-if="obj.fee" class="section-card fee-section">
          <div class="section-title">
            <div class="icon-wrapper fee-icon">
              <b-icon icon="currency-dollar"></b-icon>
            </div>
            <h2>活動費用</h2>
          </div>
          <div class="fee-list">
            <div v-for="item in obj.items" :key="item.id" class="fee-item">
              <div class="fee-header">
                <h4 v-text="item.title"></h4>
                <div class="fee-price">NT$ {{item.fee}}</div>
              </div>
              <div class="fee-description" v-html="formatDesc(item.desc)"></div>
            </div>
          </div>
        </div>

        <!-- 活動介紹 -->
        <div class="section-card description-section">
          <div class="section-title">
            <div class="icon-wrapper desc-icon">
              <b-icon icon="file-text"></b-icon>
            </div>
            <h2>活動介紹</h2>
          </div>
          <div class="content-text" v-html="obj.content"></div>
        </div>

        <!-- 注意事項 -->
        <div class="section-card notice-section">
          <div class="section-title">
            <div class="icon-wrapper notice-icon">
              <b-icon icon="exclamation-triangle"></b-icon>
            </div>
            <h2>注意事項</h2>
          </div>
          <div class="notice-text" v-text="obj.desc"></div>
        </div>

        <!-- 講師介紹 -->
        <div v-if="obj.coachs.length>0" class="section-card coaches-section">
          <div class="section-title">
            <div class="icon-wrapper coach-icon">
              <b-icon icon="people"></b-icon>
            </div>
            <h2>講師介紹</h2>
          </div>
          <div class="coaches-list">
            <div v-for="item in obj.coachs" :key="item.uid" class="coach-profile">
              <div class="coach-avatar-section">
                <b-avatar
                  :src="item.url"
                  variant="primary"
                  text="item.name"
                  size="5rem"
                  class="coach-avatar"
                ></b-avatar>
                <div class="coach-basic">
                  <h4 class="coach-name" v-text="item.displayname"></h4>
                  <p class="coach-position" v-text="item.title"></p>
                </div>
              </div>
              <div class="coach-details">
                <div class="detail-group">
                  <div class="detail-label">服務單位</div>
                  <div class="detail-text" v-text="item.company"></div>
                </div>
                <div class="detail-group">
                  <div class="detail-label">講師簡介</div>
                  <div class="detail-text" v-text="item.desc"></div>
                </div>
                <div v-if="item.finkurl!=='' || item.iinkurl!==''" class="social-section">
                  <div class="detail-label">社群連結</div>
                  <div class="social-links">
                    <a v-if="item.finkurl!==''" :href="ensureHttps(item.finkurl)" target="_blank" rel="noopener noreferrer" class="social-link facebook">
                      Facebook
                    </a>
                    <a v-if="item.iinkurl!==''" :href="ensureHttps(item.iinkurl)" target="_blank" rel="noopener noreferrer" class="social-link instagram">
                      Instagram
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 地圖區域 -->
        <div class="section-card map-section">
          <div class="section-title">
            <div class="icon-wrapper map-icon">
              <b-icon icon="geo-alt"></b-icon>
            </div>
            <h2>活動地點</h2>
          </div>
          <div class="map-wrapper">
            <GmapMap
              :center="{lat: parseFloat(obj.lat), lng:parseFloat(obj.lng) }"
              :zoom="17"
              map-type-id="roadmap"
              class="activity-map"
            >
              <GmapMarker
                :position="{lat: parseFloat(obj.lat), lng:parseFloat(obj.lng) }"
                :clickable="true"
                :draggable="false"
              />
            </GmapMap>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import MY_theme from "../../assets/json/optiondata.json";
import * as moment from "moment/moment";
//import {navigator} from 'vue2-google-maps'
import { makorgService,userService } from "../../_services"; 
import { gmapApi } from "vue2-google-maps";

export default {
  name: "Inforact",
  props: {
    obj: Object
  },
  data() {
    return {
      xurl: "",
      mytheme: MY_theme,
      iconLoading:false,
      org:null,
      show:false,
      orgName:null,
      viewMode: 'compact', // 'compact' 或 'expanded'
      currentPage: 1,
      itemsPerPage: 9, // 每頁顯示數量      
      imgs: {
        width: 0,
        height: 0
      },
      center: {
        lat: 25.03746,
        lng: 121.564558
      },
      geocoder: null,
      markers: [
        {
          position: { lat: 20, lng: 20 }
        }
      ],
      weeked:[
          { title: '星期一', value: 1 ,checked : false},
          { title: '星期二', value: 2 ,checked : false},
          { title: '星期三', value: 3 ,checked : false},
          { title: '星期四', value: 4 ,checked : false},
          { title: '星期五' , value: 5 ,checked : false},
          { title: '星期六', value: 6 ,checked : false},
          { title: '星期日', value: 0 ,checked : false},
        ],      
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    google: gmapApi,
    
    // 計算總頁數
    totalPages() {
      if (!this.obj.multiples) return 0;
      return Math.ceil(this.obj.multiples.length / this.itemsPerPage);
    },
    
    // 獲取當前頁的項目
    getCurrentPageItems() {
      if (!this.obj.multiples) return [];
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.obj.multiples.slice(start, end);
    },
    
    // 按月份分組
    getGroupedByMonth() {
      if (!this.obj.multiples) return {};
      const grouped = {};
      this.obj.multiples.forEach(item => {
        const date = new Date(item.date);
        const monthKey = `${date.getFullYear()}年${date.getMonth() + 1}月`;
        if (!grouped[monthKey]) {
          grouped[monthKey] = [];
        }
        grouped[monthKey].push(item);
      });
      return grouped;
    }
  },

  watch: {
    obj(val) {
      if (val == true) {
        this.loadmess();
      }
    },


  },  
  methods: {
    ...mapMutations("account", ["updateLove"]),
    geolocation() {
      this.google.geolocation.getCurrentPosition(position => {
        this.center.lat = position.coords.latitude;
        this.center.lng = position.coords.longitude;
      });
    },

    ensureHttps(url) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
          return 'https://' + url;
      }
      return url;
    }, 
    
    formatDesc(desc) {
      if (!desc) return '';
      // 將網址自動轉成超連結
      return desc.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
      );
    },    

    getgeocode(address) {
      //var geocoder = new VueGoogleMaps.Geocoder();
      var geocoder = new this.google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status == "OK") {
          this.center.lat = results[0].geometry.location.lat();
          this.center.lng = results[0].geometry.location.lng();
          this.markers[0].position.lat = this.center.lat;
          this.markers[0].position.lng = this.center.lng;
          this.form.center = this.center;
        } else {
          // 若轉換失敗...
          console.log(status);
        }
      });
    },

    locatorButtonPressed() {
      this.google.geolocation.getCurrentPosition(
        position => {
          this.center.lat = position.coords.latitude;
          this.center.lng = position.coords.longitude;
        },
        error => {
          console.log(error.message);
        }
      );
    },

    getmaps(data) {
      console.log(data);
    },

    getDay(va1){
      var day_list = ['日', '一', '二', '三', '四', '五', '六'];
      var date = moment(va1).toDate();
      var day  = date.getDay(); // or "new Date().getDay()";
      return '星期' + day_list[day]
    },
    getWeek(va1,va2,obj){
      var currentDate = moment(va2);
        var stopDate = moment(va1);
        let i=0;
        while (currentDate <= stopDate) {
            var tmp = moment(currentDate).toDate();
            var day  = tmp.getDay(); // or "new Date().getDay()";          
            let rs = obj.filter(el => el.value === day);
            if(rs[0].checked){
              for (let i = 0; i < this.weeked.length; i++) {
                if(this.weeked[i].value==day){
                  this.weeked[i].checked=rs[0].checked;
                  break;
                }

              }
            }
            i++;
            currentDate = moment(currentDate).add(1, 'days');
            if(i>8){
              break;
            }
        }
        return this.weeked
    },


    groupBy(array, groups, valueKey) {
      var map = new Map();
      groups = [].concat(groups);
      return array.reduce((r, o) => {
        groups.reduce((m, k, i, { length }) => {
          var child;
          if (m.has(o[k])) return m.get(o[k]);
          if (i + 1 === length) {
            child = Object.assign(...groups.map(k => ({ [k]: o[k] })), {
              [valueKey]: 0
            });
            r.push(child);
          } else {
            child = new Map();
          }
          m.set(o[k], child);
          return child;
        }, map)[valueKey] += +o[valueKey];
        return r;
      }, []);
    },

    catImg(imgs) {
      return require(`../../assets/${imgs}`);
    },

    covert(type, val) {
      if (type == "theme") {
        let rs = this.mytheme.filter(el => {
          return el.value === val;
        });
        return rs[0].title;
      }
    },
    async enterIconLoading(){
      let us = this.user.data.user
      let tmp  = {id:us.id.toString(),name:this.org.name,ids:this.org.id===undefined?'':this.org.id.toString(),priUrl:this.org.prourl===undefined?'':this.org.prourl}
      this.iconLoading = !this.iconLoading
      await this.putData(tmp).then(({ data }) => {
          if(data!==null){
            this.show=false;
            this.updateLove(data.acts_loves);
          }
        });
      this.iconLoading = !this.iconLoading
    },   
    async getOrg(id){
      let tmp= await this.queryData(id);
      this.orgName=tmp.data.name
      this.$emit("loadings",false)
      this.org = tmp.data 
      if(JSON.stringify(this.org)!=='{}' && this.user!==null){
        if(this.user.data.user.acts_loves!==null){
          //console.log(this.user.data.user.acts_loves);
          let rs = this.user.data.user.acts_loves.filter(el => {
         return el.ids.toString() === this.org.id.toString()
        });
          if(rs.length > 0) {
            this.show = false;
          }else{
            this.show = true;
          }
        }else{
          this.show = true;
        }
      }
    },
    queryData(id) {
        return new Promise((resolve) => {
            resolve(makorgService.findorg(id));
        });
     }, 
     
     putData(obj){
        return new Promise((resolve) => {
            resolve(userService.putUser(obj));
        });
        },  
        
    getDayOfWeek(dateString) {
      const date = new Date(dateString);
      const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      return days[date.getDay()];
    },
    
    // 格式化時間顯示
    formatScheduleTime(item) {
      const date = new Date(item.date);
      const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
      const weekday = weekdays[date.getDay()];
      const month = date.getMonth() + 1;
      const day = date.getDate();
      
      return `${month}/${day}(${weekday}) ${item.stime}~${item.etime}`;
    },     
    
    getDateData(myDatelist){

      const dataWithDayOfWeek = myDatelist.map(item => {
          return {
              ...item,
              dayOfWeek: this.getDayOfWeek(item.sdate)
          };
      });
      const groupedData = dataWithDayOfWeek.reduce((groups, item) => {
          const { dayOfWeek } = item;
          if (!groups[dayOfWeek]) {
              groups[dayOfWeek] = [];
          }
          groups[dayOfWeek].push(item);
          return groups;
      }, {});

      //const propertyNames = [];
      const keysArray = Object.keys(groupedData);
      return keysArray

    }
    


  },
  mounted() {
    //await this.getWeek(this.obj.fcontent.edate,this.obj.fcontent.sdate,this.obj.weeked)
  },
  created() {

  },
  beforeDestroy() {}
};
</script>
<style scoped>
/* === 優雅活動頁面設計 === */
.elegant-activity-page {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  padding: 20px;
}

.main-content {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* === 標題區塊 === */
.title-block {
  background: white;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  text-align: center;
}

.activity-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
}

.badge {
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 13px;
  font-weight: 600;
  color: white;
  letter-spacing: 0.5px;
}

.theme-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.type-badge {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.info-badge {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.main-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 24px 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.favorite-section {
  margin-top: 16px;
}

.favorite-btn {
  background: linear-gradient(135deg, #ff6b6b, #ee5a52) !important;
  border: none !important;
  border-radius: 50px !important;
  padding: 12px 28px !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3) !important;
  transition: all 0.3s ease !important;
}

.favorite-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4) !important;
}

.heart-icon {
  margin-right: 8px;
  font-size: 16px;
}

/* === 圖片區域 === */
.image-section {
  background: white;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.image-wrapper {
  border-radius: 16px;
  overflow: hidden;
  background: #f8fafc;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}

.main-image {
  width: 100%;
  max-width: 1280px;
  height: 500px;
  object-fit: cover;
  transition: transform 0.3s ease;
  display: block;
}

.main-image:hover {
  transform: scale(1.02);
}

/* === 資訊網格 === */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.info-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.info-card.full-width {
  grid-column: 1 / -1;
  margin-bottom: 20px;
}

.info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 18px;
  color: white;
}

.time-icon {
  background: linear-gradient(135deg, #667eea, #764ba2);
}

.info-icon {
  background: linear-gradient(135deg, #f093fb, #f5576c);
}

.credit-icon {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
}

.link-icon {
  background: linear-gradient(135deg, #43e97b, #38f9d7);
}

.card-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
}

.card-content {
  color: #475569;
  line-height: 1.6;
}

/* === 時間卡片特殊樣式 === */
.time-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.time-header {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.time-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.time-type {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.time-type.single {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.time-type.multi {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

.time-info {
  font-weight: 600;
  color: #1e293b;
  font-size: 16px;
  line-height: 1.5;
}

.time-period {
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}

.day-info {
  background: #f1f5f9;
  color: #475569;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
}

.day-item {
  background: #f1f5f9;
  color: #475569;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  margin: 2px 4px 2px 0;
  display: inline-block;
}

.day-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.schedule-times-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
}

.schedule-time {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  padding: 12px;
  transition: all 0.2s ease;
}

.schedule-time:hover {
  background: #dbeafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.schedule-date {
  font-weight: 600;
  color: #1e40af;
  font-size: 13px;
  margin-bottom: 4px;
}

.schedule-time-range {
  color: #475569;
  font-size: 12px;
  font-weight: 500;
}

/* === 新增的時間列表樣式 === */
.schedule-times-container {
  margin-top: 16px;
}

.schedule-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.total-count {
  font-size: 14px;
  color: #64748b;
  font-weight: 600;
}

.view-controls {
  display: flex;
  gap: 8px;
}

.view-btn {
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.view-btn:hover:not(.active) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.schedule-compact {
  display: flex;
  flex-direction: column;
}

.schedule-times {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.schedule-item {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #1e40af;
  text-align: center;
  transition: all 0.2s ease;
}

.schedule-item:hover {
  background: #dbeafe;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
}

.page-btn {
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.page-info {
  font-size: 14px;
  color: #64748b;
  font-weight: 600;
  min-width: 60px;
  text-align: center;
}

.schedule-expanded {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.month-group {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.month-header {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  padding: 8px 12px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-radius: 8px;
  display: inline-block;
}

/* === 基本資訊卡 === */
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}

.info-row:last-child {
  border-bottom: none;
}

.label {
  font-weight: 600;
  color: #64748b;
  min-width: 80px;
  font-size: 14px;
}

.value {
  color: #1e293b;
  text-align: left;
  flex: 1;
  margin-left: 12px;
  font-size: 14px;
}

/* === 學分網格 === */
.credit-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.credit-item {
  text-align: center;
  background: #f8fafc;
  padding: 12px 8px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.credit-role {
  display: block;
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 4px;
}

.credit-value {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

/* === 連結卡片 === */
.external-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
  padding: 8px 16px;
  background: #eff6ff;
  border-radius: 10px;
  transition: all 0.3s ease;
  font-size: 14px;
}

.external-link:hover {
  background: #dbeafe;
  color: #1d4ed8;
  text-decoration: none;
}

.no-link {
  color: #94a3b8;
  font-style: italic;
  text-align: center;
  padding: 16px;
}

.restriction-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.restriction-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 4px;
}

.restriction-value {
  color: #dc2626;
  font-weight: 600;
  font-size: 14px;
}

/* === 區域卡片 === */
.section-card {
  background: white;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
}

.section-title h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #1e293b;
}

.fee-icon {
  background: linear-gradient(135deg, #10b981, #059669);
}

.desc-icon {
  background: linear-gradient(135deg, #8b5cf6, #a855f7);
}

.notice-icon {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.coach-icon {
  background: linear-gradient(135deg, #ec4899, #be185d);
}

.map-icon {
  background: linear-gradient(135deg, #06b6d4, #0891b2);
}

/* === 費用清單 === */
.fee-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fee-item {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.fee-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.fee-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.fee-price {
  font-size: 18px;
  font-weight: 800;
  color: #059669;
  background: #d1fae5;
  padding: 6px 12px;
  border-radius: 8px;
}

.fee-description {
  color: #475569;
  line-height: 1.6;
  font-size: 14px;
}

/* === 內容文本 === */
.content-text {
  color: #374151;
  line-height: 1.8;
  font-size: 15px;
}

.notice-text {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 12px;
  padding: 20px;
  color: #92400e;
  line-height: 1.7;
  font-weight: 500;
}

/* === 講師列表 === */
.coaches-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.coach-profile {
  background: #f8fafc;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.coach-profile:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.coach-avatar-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.coach-avatar {
  border: 3px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.coach-basic {
  flex: 1;
}

.coach-name {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.coach-position {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

.coach-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-group {
  background: white;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.detail-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 6px;
}

.detail-text {
  color: #1e293b;
  line-height: 1.6;
  font-size: 14px;
}

.social-section {
  background: white;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.social-links {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.social-link {
  padding: 6px 12px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.social-link.facebook {
  background: #1877f2;
  color: white;
}

.social-link.instagram {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: white;
}

.social-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  color: white;
  text-decoration: none;
}

/* === 地圖區域 === */
.map-wrapper {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.activity-map {
  width: 100%;
  height: 350px;
}

/* === 響應式設計 === */
@media (max-width: 768px) {
  .elegant-activity-page {
    padding: 12px;
  }
  
  .main-content {
    gap: 16px;
  }
  
  .title-block, .section-card {
    padding: 20px;
  }
  
  .main-title {
    font-size: 1.8rem;
  }
  
  .activity-badges {
    flex-direction: column;
    align-items: center;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .credit-grid {
    grid-template-columns: 1fr;
  }
  
  .coach-avatar-section {
    flex-direction: column;
    text-align: center;
  }
  
  .fee-header {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  
  .activity-map {
    height: 250px;
  }
  
  /* 圖片響應式 */
  .main-image {
    height: 300px;
  }
  
  /* 時間卡片響應式 */
  .time-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .schedule-times-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  /* 新增時間列表響應式 */
  .schedule-summary {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  
  .view-controls {
    align-self: stretch;
  }
  
  .view-btn {
    flex: 1;
  }
  
  .schedule-times {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .title-block, .section-card {
    padding: 16px;
  }
  
  .info-card {
    padding: 16px;
  }
  
  .main-title {
    font-size: 1.6rem;
  }
  
  .info-row {
    flex-direction: column;
    gap: 4px;
  }
  
  .value {
    text-align: left;
    margin-left: 0;
  }
  
  /* 時間卡片小螢幕優化 */
  .time-type {
    padding: 4px 10px;
    font-size: 11px;
  }
  
  .time-info {
    font-size: 13px;
  }
  
  .day-item, .day-info {
    font-size: 12px;
    padding: 3px 8px;
  }
  
  .schedule-times-grid {
    grid-template-columns: 1fr;
  }
  
  /* 新增時間列表小螢幕樣式 */
  .schedule-times {
    grid-template-columns: 1fr;
  }
  
  .view-controls {
    flex-direction: column;
  }
}

/* === 動畫效果 === */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.info-card, .section-card {
  animation: fadeInUp 0.5s ease-out;
}

/* === 優化滾動條 === */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
<style>
/* === 全局樣式優化 === */
.content-text img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  margin: 20px 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.content-text img:hover {
  transform: scale(1.02);
}

.content-text p {
  margin-bottom: 16px;
  line-height: 1.8;
  color: #374151;
}

.content-text h1,
.content-text h2,
.content-text h3,
.content-text h4 {
  margin-top: 28px;
  margin-bottom: 16px;
  color: #1e293b;
  font-weight: 700;
  line-height: 1.4;
}

.content-text h1 {
  font-size: 1.8rem;
}

.content-text h2 {
  font-size: 1.5rem;
}

.content-text h3 {
  font-size: 1.3rem;
}

.content-text ul,
.content-text ol {
  margin: 16px 0;
  padding-left: 28px;
}

.content-text li {
  margin-bottom: 8px;
  line-height: 1.7;
}

.content-text a {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
  border-bottom: 1px solid transparent;
  transition: all 0.3s ease;
}

.content-text a:hover {
  color: #1d4ed8;
  border-bottom-color: #1d4ed8;
}

.content-text blockquote {
  background: #f8fafc;
  border-left: 4px solid #3b82f6;
  padding: 16px 20px;
  margin: 20px 0;
  border-radius: 8px;
  font-style: italic;
  color: #475569;
}

.fee-description a {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
}

.fee-description a:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

/* === 表格樣式 === */
.content-text table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.content-text th,
.content-text td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.content-text th {
  background: #f8fafc;
  font-weight: 600;
  color: #374151;
}

.content-text tr:hover {
  background: #f8fafc;
}

/* === 代碼樣式 === */
.content-text code {
  background: #f1f5f9;
  color: #1e293b;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.9em;
}

.content-text pre {
  background: #1e293b;
  color: #e2e8f0;
  padding: 20px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 20px 0;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.content-text pre code {
  background: transparent;
  color: inherit;
  padding: 0;
}

/* === 響應式圖片和媒體 === */
@media (max-width: 768px) {
  .content-text img {
    margin: 16px 0;
  }
  
  .content-text h1 {
    font-size: 1.6rem;
  }
  
  .content-text h2 {
    font-size: 1.4rem;
  }
  
  .content-text h3 {
    font-size: 1.2rem;
  }
  
  .content-text table {
    font-size: 14px;
  }
  
  .content-text th,
  .content-text td {
    padding: 8px 12px;
  }
}

/* === 打印樣式 === */
@media print {
  .elegant-activity-page {
    background: white;
    padding: 0;
  }
  
  .favorite-btn {
    display: none;
  }
  
  .social-links {
    display: none;
  }
  
  .main-content {
    box-shadow: none;
  }
  
  .section-card,
  .info-card {
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }
}
</style>

